<template>
	<!-- 搜索面板组件，数据来自table -->
	<!--【name】:标题，【attr】:搜索的属性名 ，【type】："text:文本框 ，date:日期 , dialog:弹出框" ，【isRange】:true的话会有两个框 ,【dictionary】：业务字典在数据库中的名称-->
	<!-- 文本框 ，date ，date+range ， dialog -->
	<!-- showBtn的list参数，后续还有新的按钮再说"showQueryAll", "showQueryItem", "showEdit", "showEb" //showBtn = ["showQueryAll" , "showEb"] -->
	<!-- tableCode :多个表格的时候用来绑定表格 -->
	<div class="search-panel">
		<ul class="search-text" v-show="show_search_text">
			<li v-for="(temp ,index) in searchdata" :key="temp.attr" :class="canBorder(index)">
				<base-search v-if="temp.type === 'text' && temp.isRange === false" :obj="temp">
					<div class="input-group">
						<input :name="'seek_'+temp.attr" type='text' class='form-control' v-model.trim='bind_data[temp.attr]' @keyup.enter="enterSearch">
					</div>
				</base-search>
                <base-search v-if="temp.type === 'projectName' && temp.isRange === false" :obj="temp">
                    <div class="input-group">
                        <input :name="'seek_'+temp.attr" type='text' class='form-control' v-model.trim='bind_data[temp.attr]' disabled>
                        <button type="button" class="btn btn-primary" @click="showPro()" style="padding: 2px 12px;font-size: 12px;float:left;margin-left:4px;">选择</button>
                    </div>
                </base-search>
                <base-search v-if="temp.type === 'companyName' && temp.isRange === false" :obj="temp">
                    <div class="input-group">
                        <input :name="'seek_'+temp.attr" type='text' class='form-control' v-model.trim='bind_data[temp.attr]' disabled>
                        <button type="button" class="btn btn-primary" @click="showOrgList()" style="padding: 2px 12px;font-size: 12px;float:left;margin-left:4px;">选择</button>
                    </div>
                </base-search>
				<select-search v-if=" temp.type === 'select' && temp.dictionary !='' " :obj="temp" :Dictionaries="dirs">
					<template scope='props'>
						<div class="input-group">
							<select :name="'seek_'+temp.attr" class='form-control' v-model="bind_data[temp.attr]">
								<option v-for='a in props.select_list' :value='a.code' :key='a.code'>{{a.name}}</option>
							</select>
						</div>
					</template>
				</select-search>
				<!-- 资质等级 -->
				<span class="quallevelName" v-if=" temp.type === 'qualLevel'">{{temp.name}}：</span>
				<div class="input-group" v-if=" temp.type === 'qualLevel'">
					<select :name="'seek_'+temp.attr" class='form-control' v-model="bind_data[temp.attr]" style="width:auto;display:table-cell;">
						<option v-for='q in dirs.qualLevel.grade' :value='q.code' :key='q.code'>{{q.name}}</option>
					</select>
					<select :name="'seek_'+temp.attr" class='form-control' v-model="bind_data['qualGrade']" style="width:auto;display:table-cell;">
						<option v-for='b in dirs.qualLevel.level' :value='b.code' :key='b.code'>{{b.name}}</option>
					</select>
				</div>
				<!-- <date-search v-if=" data.type === 'date' && data.isRange === false" :obj="data"></date-search> -->
				<range-date-search v-if="temp.type === 'date' && temp.isRange === true" :obj="temp">
					<div class="input-group">
						<el-date-picker v-model="bind_data[temp.children.startAttr]" type="date" format="yyyy-MM-dd" :class="temp.children.startAttr"></el-date-picker>
						<label style="float:left;padding:0 3px 0 3px">~</label>
						<el-date-picker v-model="bind_data[temp.children.endAttr]" type="date" format="yyyy-MM-dd" :class="temp.children.endAttr"></el-date-picker>
					</div>
				</range-date-search>

				<dialog-search v-if=" temp.type === 'dialog'" :obj="temp">
					<div class="input-group">
						<input :name="'seek_'+temp.attr" type='text' class='form-control' v-model='bind_data[temp.children.attrName]'>
						<input :name="'seek_'+temp.attr" type="text" hidden v-model="bind_data[temp.children.attrId]">
						<button type="button" class="btn btn-primary" @click="showDialog(temp.attr)" style="padding: 2px 12px;font-size: 12px;float:left;margin-left:4px;">选择</button>
					</div>
				</dialog-search>
			</li>
		</ul>
		<div class="search-btn-group">
			<button v-for="(val,index) in showBtn" :key="index" type="button" class="btn btn-primary" @click="btnClick(val.attr)" v-if="bind_dis_btn[val.attr]" :class="{fright:val.float=='right'}">
				{{val.label}}
			</button>
			<button type="button" class="btn btn-primary showClear" @click="clear" v-if="showClear">清空条件</button>
			<!-- passLimit 返回指令 和 搜索框内容 -->
		</div>
		<!-- 考评主体 -->
		<check-main-body v-if="dialogName==='checkMainBody'" @passMainBody="getMainBody" @closeDialog="dialogName=''"></check-main-body>
		<aptitude-level v-if="dialogName==='aptitudeLevel'" @passSelection="getSelection" @closeDialog="dialogName=''"></aptitude-level>
        <el-dialog title="选择项目" v-if="showProject" :visible.sync="showProject">
            <el-table v-loading="loadingPro" element-loading-text="加载中，请稍候"
                      :data="proData" border tooltip-effect="dark" style="width: 100%;height: auto;" highlight-current-row>
                <el-table-column prop="proName"  label="项目名称"></el-table-column>
                <el-table-column  label="操作" width="80px">
                    <template scope="scope">
                        <!--<button type="text" @click="select()">选择</button>-->
                        <el-button type="text" @click="select(scope.row)">选择</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <center slot="footer" class="detail-btn-group" style="margin-top:10px;width:100%">
                <button class="btn btn-primary" @click="showProject = false">关闭</button>
            </center>
        </el-dialog>
        <el-dialog title="选择检查机构" v-if="showOrg" :visible.sync="showOrg">
            <search-panel ref="searchPanel" :searchdata="searchdata_" :showBtn="showBtn_" @passLimit="getLimit"></search-panel>
            <el-table v-loading="loadingOrg" element-loading-text="加载中，请稍候"
                      :data="orgData" border tooltip-effect="dark" style="width: 100%;height: auto;" highlight-current-row>
                <el-table-column type="index" width="70"></el-table-column>
                <el-table-column prop="orgCode" label="检测机构代码"> </el-table-column>
                <el-table-column prop="area" label="地区"> </el-table-column>
                <el-table-column prop="companyName" label="检测机构名称"> </el-table-column>
                <el-table-column  label="操作" width="80px">
                    <template scope="scope">
                        <el-button type="text" @click="selectOrg(scope.row)">选择</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="float:right" id="app_pagination">
                <el-pagination @current-change="handleCurrentChange" :current-page="page" :page-size="pageSize" layout="total, jumper, prev, pager, next" :total="total">
                </el-pagination>
            </div>
            <center slot="footer" class="detail-btn-group" style="margin-top:10px;width:100%">
                <button class="btn btn-primary" @click="showOrg = false">关闭</button>
            </center>
        </el-dialog>
	</div>
</template>
<script>
import { API_ProjectMaterials } from "@/api/api.js"
// import { Dictionaries } from "@/resources.js"
import checkMainBody from "@/components/pages/safetyCheck/check_main_body.vue"
import aptitudeLevel from "@/components/pages/safetyCheck/aptitude_level.vue"
export default {
	props: ["searchdata", "showBtn", "tableCode", "dirs", "showClearBtn"],
	data() {
		return {
			show_search_text: true,
			bind_data: {},
			bind_dis_btn: {},//暂时是绑定按钮是否显示//this.$refs.searchPan.bind_dis_btn.release = false;
			showClear: true,
			checkMainBody: false,//考评主体选择
			dialogName: "",
            showProject: false,
            proData: [],
            loadingPro: false,
            showOrg: false,
            loadingOrg: false,
            searchdata_: [
                { name: "检测机构名称", attr: "companyName", type: "text", isRange: false, "dictionary": "" },
                { name: "地区", attr: "area", type: "text", isRange: false, "dictionary": "" },
                { name: "检测机构代码", attr: "orgCode", type: "text", isRange: false, "dictionary": "" },
            ],
            showBtn_: [
                { "label": "搜索", attr: "queryAll" }
            ],
            limit: {},
            pageSize: 20,
            page: 1,
            total: 0,
            orgData: []
		};
	},
	watch: {//适应幕墙。以后改掉
		showBtn() {
			this.showBtn.forEach((item) => {//绑定参数到按钮
				this.$set(this.bind_dis_btn, item.attr, true)
			})
		}
	},
	created() {
		var bind_data = {};//绑定input的v-model
		for (let i = 0, a = this.searchdata; i < a.length; i++) {
			if (a[i].isRange === true && a[i].type === "date") {
				this.$set(this.bind_data, a[i].children.startAttr, "")
				this.$set(this.bind_data, a[i].children.endAttr, "")
			} else if (a[i].type === "dialog") {
				this.$set(this.bind_data, a[i].children.attrId, "")
				this.$set(this.bind_data, a[i].children.attrName, "")
			} else {
				this.$set(this.bind_data, a[i].attr, "")
			}
		}
		this.showBtn.forEach((item) => {//绑定参数到按钮
			this.$set(this.bind_dis_btn, item.attr, true)
		})
		if (this.searchdata.length === 0)//没有输入框则删除输入框面板
			this.show_search_text = false;
	},
	mounted() {
		let me = this;
		$(document).on('change', '.el-date-editor.el-input.el-date-editor--date>.el-input__inner', function(e) {
			let val = e.target.value;
			if(val != ""){
                let str = $(e.target).parent()[0].className;
                let str1 = str.slice(45,str.length);
                if (!me.checkDate(val)) {
                    me.$set(me.bind_data,str1,"");
                    me.$alert("请输入格式为yyyy-MM-dd的日期", "提醒", {
                        confirmButtonText: "确定",
                        type: "warning"
                    });
                    return "";
                }
            }
		});
		if (this.showClearBtn != null) {
			this.showClear = this.showClearBtn;
		}
	},
	methods: {
        showPro() {
          this.showProject = true;
          this.queryPro()
        },
        queryPro() {
            this.loadingPro = true
            API_ProjectMaterials.getProjectMaterialDetail({type: "add"}).then(res => {
                this.proData = res.hyprojects
                this.loadingPro = false
            })
        },
        select(row) {
            this.bind_data.projectName = row.proName;
            this.showProject = false;
        },
        showOrgList() {
            this.showOrg = true;
            this.queryOrg()
        },
        getLimit(params) {
            switch (params[0]) {
                case "queryAll":
                {
                    let t_limit = params[1];
                    let limit = {};
                    for (var i in t_limit) {
                        if (t_limit[i] && t_limit[i].length > 0) {
                            limit[i] = t_limit[i];
                        }
                    }
                    this.limit = limit;
                }
                    this.queryOrg();
                    break;
            }
        },
        queryOrg() {
            let limit = {};
            for (let i in this.limit) {
                limit[i] = this.limit[i];
            }
            this.orgData = [];
            this.loadingOrg = true;
            this.currentRow = {};
            let v = 0;
            for(let i in limit){
                v++;
            }
            API_ProjectMaterials.listTestOrg(this.pageSize + "/" + this.page, v == 0 ? {} : { limit: limit }).then(res => {
                if (res == null) {
                    this.$alert('获取中润检测机构失败，请稍后刷新重试', '', {
                        confirmButtonText: '确定',
                        type: "error"
                    });
                    this.loadingOrg = false;
                } else {
                    this.orgData = res.dataList;
                    this.total = res.totalRowNum;
                    this.loadingOrg = false;
                }
            })
        },
        handleCurrentChange(val) {
            this.page = val;
            this.queryOrg();
        },
        selectOrg(row) {
            this.bind_data.companyName = row.companyName
            this.bind_data.jcjgid = row.orgCode
            this.showOrg = false
            this.limit = {}
            this.pageSize = 20
            this.page = 1
            this.total = 0
            this.orgData = []
        },
		enterSearch() {
			this.$emit("passLimit", ["queryAll", this.bind_data, this.tableCode])
		},
		clear() {
			for (let i in this.bind_data) {
                this.$set(this.bind_data, i, "");
			}
			$(".el-date-editor.el-input.el-date-editor--date>.el-input__inner").val("")
            if (this.bind_data.jcjgid !== undefined) {
                this.bind_data.jcjgid = ''
            }
		},
		showDialog(val) {
			this.dialogName = val;
		},
		getMainBody(val) {
			this.bind_data.positionname ? this.bind_data.positionname = val : this.bind_data.positionName = val;
			this.bind_data.positionid ? this.bind_data.positionid = "2333" : this.bind_data.positionId = "2333";
		},
		getSelection(val) {
			this.bind_data.quallevalmc = "";
			// 资质等级的选中list -- 资质等级好像都是小写
			for (let i in val) {
				if (i < val.length - 1) {
					this.bind_data.quallevalmc += val[i] + ",";
				}
				else {
					this.bind_data.quallevalmc += val[i];
				}
			}
		},
		canBorder: function(index) {
			if ((index + 1) % 3 != 0)
				return { "border-right": true }
		},
		btnClick(attr) {
			this.$emit("passLimit", [attr, this.bind_data, this.tableCode])
		},
		setAttr(elName, attrName, val) {
			this.$set("")
		},
        checkDate(value){
            let dateStr = "";
            //可能传过来
            if (value.length < 10 || value[4] != "-" || value[7] != "-") {
                return false;
            }
            dateStr = new Date("" + value);
            if (isNaN(dateStr.getDate())) {
                return false;
            } else if (!/^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/.test(value)) {
                return false;
            }
            const year = value.split("-")[0];
            const month = value.split("-")[1];
            const date = value.split("-")[2];
            const big_month = ["01", "03", "05", "07", "08", "10", "12"];
            const small_month = ["04", "06", "09", "11"];
            //被4整除但不能被100整除，或能被400整除的年份即为闰
            if ((year % 4 == 0 && year % 100 != 0) || (year % 400 == 0)) {
                if (month == 2 && date > 29)
                    return false;
            } else {
                if (month == 2 && date > 28)
                    return false;
                let big_include = false;
                for (let i in big_month) {
                    if (big_month[i] == month) {
                        big_include = true;
                        break;
                    }
                }
                let small_include = false;
                for (let i in small_month) {
                    if (small_month[i] == month) {
                        small_include = true;
                        break;
                    }
                }
                if (month == 2 && date > 29) {
                    return false;
                } else if (big_include && parseInt(date) > 31) { // big_month.includes(month)
                    return false;
                } else if (small_include && parseInt(date) > 30) { //small_month.includes(month)
                    return false;
                }
            }
            return true;
        }
	},
	components: {
        SearchPanel: () => import('./search_panel_new.vue'),
		checkMainBody: checkMainBody,
		aptitudeLevel: aptitudeLevel,
		"base-search": {//标题+文本框的搜索
			props: ["obj"],
			template: `<center class='base-search ' style='width:100%'>
                             <span class=''>{{obj.name}}：</span>
                             <slot></slot>
                        </center>`
		},
		"select-search": {//标题+下拉框(来自数据库)的搜索
			props: ["obj", "Dictionaries"],
			data() {
				//getByDicName(this.obj.dictionary)
				return {
					select_list: this.getListByDicName(this.obj.dictionary),
				}
			},
			methods: {
				getListByDicName(dictionary) {
					return this.Dictionaries[dictionary];
				}
			},
			template: `<center class='base-search ' style='width:100%'>
                            <span class=''>{{obj.name}}：</span>
                            <slot :select_list='select_list'></slot>
                        </center>`
		},
		"range-date-search": {//日期跨度搜索
			props: ["obj"],
			methods: {

			},
			template: `<center class='base-search ' style='width:100%'>
                            <span class=''>{{obj.name}}：</span>
                            <slot></slot>
                        </center>`
		},
		"dialog-search": {//弹出框搜索
			props: ["obj"],
			template: `<center class='base-search' style='width:100%'>
                            <span class=''>{{obj.name}}：</span>
                            <slot></slot>
                        </center>`

		}
	}
}
</script>
<style>
.search-panel {
	float: left;
	width: 100%;
	padding: 5px;
}

.search-panel>.search-text,
.search-panel>.search-btn-group {
	padding: 5px;
	margin: 5px 0;
	border: 1px #e6e5e5 solid;
	width: 100%;
}

.search-panel>.search-btn-group>.btn.btn-primary {
	font-size: 13px;
	padding: 2px 12px;
	margin-right: 5px;
}

.search-panel>.search-text>li {
	list-style: none;
	width: 33.3%;
	display: inline-block;
	padding: 0px;
}

.search-panel center {
	width: 100%;
	display: table;
	position: relative;
}

.search-panel .input-group {
	display: table-cell;
	padding-left: 5px;
}

.search-panel>.search-text>li>center>span,
.quallevelName {
	width: 30%;
	text-align: right;
	display: table-cell;
	vertical-align: middle;
}

.search-panel>.search-text>li .form-control,
.search-panel>.search-text>li .el-input__inner {
	height: 25px;
	padding: 0;
    width: 90%;
	max-width: 200px;
	display: table-cell;
	z-index: 2;
	border-radius: 4px;
	border: 1px solid #ccc;
}

.search-panel .el-date-editor.el-input {
	width: 46%;
	float: left;
}

.search-panel>.search-text>li .el-input__inner {
	width: 100%;
}

.search-panel>.search-text>li.border-right {
	border-right: 1px #e6e5e5 solid;
}

.fright {
	float: right;
}
</style>






// WEBPACK FOOTER //
// search_panel_new.vue?1c8ee725